import 'slick-carousel/slick/slick'

export default class TestimonialsSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-testimonials-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                adaptiveHeight: true,
                appendDots: $('.js-testimonials-slider-dots'),
            });
        }

    }

};

new TestimonialsSlider();